<!-- <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>La frequenza ad un percorso di formazione organizzato in relazione ad uno dei profili professionali del QRSP abilita
            a
            svolgere un'attività professionale?</h3>
      </mat-panel-title>
      <mat-panel-description>
        This is a summary of the content
      </mat-panel-description>
    </mat-expansion-panel-header>
   
    
  </mat-expansion-panel> -->


  <mat-accordion>

    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>
            <h3>La frequenza ad un percorso di formazione organizzato in relazione ad uno dei profili professionali del QRSP abilita
                a
                svolgere un'attività professionale?</h3>
        </mat-panel-title>

      </mat-expansion-panel-header>
      <p>I profili professionali e le competenze della sezione profili professionali QRSP definiscono solo qualificazioni
        professionali e quindi l'attestato relativo non abilita ad alcuna attività professionale.</p>
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelOpenState = true"
                         (closed)="panelOpenState = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
            <h3>Gli enti accreditati devono tener conto dei Profili professionali e delle competenze del Quadro Regionale degli
                Standard
                Professionali per l'organizzazione dei percorsi professionalizzanti?</h3>
        </mat-panel-title>
       
      </mat-expansion-panel-header>
      <p>Il QRSP è il punto di riferimento univoco e imprescindibile per l'organizzazione di percorsi di formazione continua,
        permanente e di specializzazione e per la certificazione delle competenze.</p>
    
    <p>Pertanto, gli enti di formazione accreditati, che intendano attivare percorsi di formazione che rilascino un
        attestato
        regionale, devono tassativamente ricondurre l'offerta formativa ad una o più competenze o a profili professionali
        esplicitati nel QRSP.</p>
    
    <p>E' possibile progettare percorsi formativi che utilizzano competenze all'interno del QRSP sia pure 'pescate' da
        profili
        diversi, ma il percorso formativo 'aggregato' non può avere una denominazione diversa dai profili espressamente
        inseriti
        nel QRSP.</p>
    
    <p>La certificazione e il rilascio dell'Attestato non sono previsti nel caso in cui la durata o la configurazione del
        percorso non permettano l'acquisizione compiuta di competenze, bensì solo di alcuni suoi elementi costitutivi;
        l'unico
        attestato regionale previsto dalla normativa (LR 19/2007 e atti attuativi) è l'attestato di competenza.</p>
    
    <p>Eventuali dichiarazioni di partecipazione al percorso, rilasciati dagli enti accreditati, non possono riportare il
        logo
        regionale. Qualora il percorso formativo sia finanziato attraverso una politica regionale (per esempio Dote Unica
        Lavoro
        o Garanzia Giovani) è necessario citare l'iniziativa all'interno della dichiarazione di partecipazione al percorso
        formativo.</p>
    </mat-expansion-panel>
  </mat-accordion>




